import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { ApplyAsCandidateModal } from '../../candidate-apply-form/modals';
import { ApplyAsAgencyModal } from '../../agency-apply-form/modals';
import { WrapperReduxStore } from '../../shared/components';

export const VacancyDescription = ({ description, whatWeOffer, forCandidates }) => {
    const { t } = useTranslation('PayseraRecruitmentBundle');

    function createMarkup(item) {
        const [label, text] = item.split(':');
        return (
            <><strong>{ label }:</strong>&nbsp;{ text }</>
        );
    }

    return (
        <>
            <div
                className="vacancy-description"
                dangerouslySetInnerHTML={{ __html: description }}
            />
            {whatWeOffer && (
                <>
                    <h3 className="vacancy-offer-item-header">
                        <strong>
                            {t('career_offer.what_we_offer')}:
                        </strong>
                    </h3>
                    <div>
                        {whatWeOffer.split('\n').map((item, key) => (
                            <p key={key}>
                                {createMarkup(item)}
                            </p>
                        ))}
                    </div>
                </>
            )}
            {forCandidates && (
                <>
                    <h3 className="vacancy-offer-item-header">
                        <strong>
                            {t('career_offer.for_candidates')}:
                        </strong>
                    </h3>
                    {forCandidates}
                </>
            )}
            <div className="vacancy-offer-apply">
                <WrapperReduxStore>
                    <ApplyAsCandidateModal />
                </WrapperReduxStore>
                <WrapperReduxStore>
                    <ApplyAsAgencyModal />
                </WrapperReduxStore>
            </div>
        </>
    );
};

VacancyDescription.propTypes = {
    description: PropTypes.string.isRequired,
    whatWeOffer: PropTypes.string,
    forCandidates: PropTypes.string,
};

VacancyDescription.defaultProps = {
    whatWeOffer: null,
    forCandidates: null,
};
